















import { Component, Vue, Prop } from 'vue-property-decorator';
import PhotoClip from 'photoclip';
import { Getter, Action } from 'vuex-class';
import getUrlParam from '@/common/utils/getUrlParam';
import store from '@/store';
import uploadOss from '@/common/utils/uploadOss';
import { AxiosPromiseData } from '@/common/interface';
import { majorNoticeText, SIZE_UNIT } from '@/common/constants/index';
import { validateImageType } from '@/common/utils';
import Bridge from '@/common/bridge';
import { isXiaomaiApp, isXiaoMaiIOSApp, isXiaoMaiAndroidApp } from '@/common/utils/getPlaform';
@Component
export default class ImageUpload extends Vue {
  @Prop() index!: number;
  @Prop() cutType!: string;
  @Getter('xcxFlag') xcxFlag!: boolean;
  @Getter('xmMajordomo') xmMajordomo!: boolean;
  @Getter('mainBackgroundColor') mainBackgroundColor!: string;
  @Getter('gachaTypeParameter') gachaTypeParameter!: object;
  @Action('changeShowFooter') changeShowFooter!: Function;
  @Getter('xcxType') xcxType!: string;

  showMask: boolean = false;
  name: string = '';
  type: string = '';
  isUploadPrizeImg: boolean = store.state.gachaTypeParameter.gachaType == 'prize';

  handleClick(): void {
    console.log(this.xcxType, 'xcxType');
    if (this.xcxType === 'mkb') {
      return;
    }
    if (this.xcxFlag && !this.xmMajordomo && !this.isUploadPrizeImg) {
      Vue.$confirm({
        oneBtn: true,
        title: '提示',
        text: majorNoticeText,
        okText: '确定'
      });
      return;
    }
    (this.$refs.inputFile as HTMLInputElement).click();
  }

  uploadImg(event: Event): void {
    const that = this;
    const qrcode = (event.target as HTMLInputElement).files![0];
    if (!validateImageType(qrcode.type)) {
      Vue.$toast.info('只能上传jpg,png格式的图片');
      return;
    }
    this.name = qrcode.name;
    this.type = qrcode.type;
    if (qrcode) {
      if (!isXiaoMaiAndroidApp()) {
        const reader = new FileReader();
        reader.onload = function(event) {
          const image = new Image();
          image.onload = function() {
            const width = (this as any).width;
            const height = (this as any).height;
            if (width < window.innerWidth) {
              // 图片小于截取框
              const canvas: HTMLCanvasElement = document.createElement('canvas');
              const context = canvas.getContext('2d') as CanvasRenderingContext2D;
              canvas.width = window.innerWidth;
              canvas.height = (height / width) * window.innerWidth;
              context.drawImage(image, 0, 0, canvas.width, canvas.height);
              const base64 = canvas.toDataURL('image/jpeg');
              that.startCutImage(base64);
            } else {
              that.startCutImage(qrcode);
            }
          };
          image.src = (event as any).target.result;
        };
        reader.readAsDataURL(qrcode);
      } else {
        // 安卓小麦App
        if (qrcode.size > 20 * SIZE_UNIT) {
          Vue.$toast.info('图片大小不能超过20M');
          return;
        }
        const loading = window.weui.loading();
        const bizCode = Number(getUrlParam('id')) === 12500 ? 'AI_ADMISSIONS' : 'XM_SHOW';
        uploadOss.newUploadBlobToOSS(qrcode as Blob, this.name, this.type, bizCode).then((res: string) => {
          const tempRes = res;
          console.log(res, 'res');
          loading.hide();
          if (this.index !== undefined) {
            this.$emit('upload', tempRes, this.index);
          } else {
            this.$emit('upload', tempRes);
          }
          window.scrollBy(0, 1);
          this.changeShowFooter(true);
        });
      }
    }
    const imageCutDom = document.getElementsByClassName('image-cut-upload');
    Array.from(imageCutDom).forEach((dom: any) => {
      dom.value = '';
    });
  }

  startCutImage(file: File | String): void {
    this.showMask = true;
    this.changeShowFooter(false);
    if (isXiaoMaiAndroidApp()) {
      console.log('isXiaoMaiAndroidApp');
    }
    this.$nextTick(() => {
      const okBtnDom = document.querySelector('.image-cut-ok-btn');
      const options: any = {
        size: [window.innerWidth, (window.innerWidth * 58) / 75],
        rotateFree: false,
        ok: okBtnDom,
        style: {
          jpgFillColor: 'transparent'
        },
        done: (dataUrl: string) => {
          this.showMask = false;
          const cutImage = this.convertBase64UrlToBlob(dataUrl);
          if (!cutImage) {
            Vue.$toast.info('图片大小不能超过20M');
            return;
          }

          if (!validateImageType((cutImage as Blob).type)) {
            Vue.$toast.info('只能上传jpg,png格式的图片');
            return;
          }

          const loading = window.weui.loading();
          const bizCode = Number(getUrlParam('id')) === 12500 ? 'AI_ADMISSIONS' : 'XM_SHOW';
          uploadOss.newUploadBlobToOSS(cutImage as Blob, this.name, this.type, bizCode).then((res: string) => {
            const tempRes = res;
            loading.hide();
            if (this.index !== undefined) {
              this.$emit('upload', tempRes, this.index);
            } else {
              this.$emit('upload', tempRes);
            }
            window.scrollBy(0, 1);
            this.changeShowFooter(true);
          });
        }
      };
      // 扭蛋机抽奖品1：1裁切
      if (this.isUploadPrizeImg) {
        options.size = [window.innerWidth, window.innerWidth];
      }
      // 1：1正方形裁切
      if (this.cutType === 'square') {
        options.size = [window.innerWidth, window.innerWidth];
      }
      // Bridge.callHandler((Api: any) => {
      //   Api.photoPicker2({ enableCrop: false, bizCode: 'XM_SHOW' })
      // });
      
      const pc = new window.PhotoClip('#imageCutContent', options);
      // const pc = new (PhotoClip as any)('#imageCutContent', options);
      pc.load(file);
    });
  }

  // base64转换成blol
  convertBase64UrlToBlob(urlData: string): Blob | boolean {
    const bytes = window.atob(urlData.split(',')[1]);
    const ab: ArrayBuffer = new ArrayBuffer(bytes.length);
    const ia: Uint8Array = new Uint8Array(ab);
    for (let i = 0; i < bytes.length; i++) {
      ia[i] = bytes.charCodeAt(i);
    }

    const blob = new Blob([ab], { type: 'image/png' });
    if (blob.size > 20 * SIZE_UNIT) {
      return false;
    }
    return new Blob([ab], { type: 'image/png' });
  }

  // 取消截图
  handleCancleCutImage(): void {
    this.changeShowFooter(true);
    this.showMask = false;
  }
}
